import React from 'react';
import smartphonePng from './smartphone.png';
import './button.scss';

const SvGBlackBtn = ({ onClick }) => {
  const handleClick = (e) => {
    if (typeof onClick === 'function') {
      onClick(e);
    }
    if (
      typeof window !== 'undefined' &&
      typeof window.dispatchEvent === 'function'
    ) {
      window.dispatchEvent(new CustomEvent('svgblackbtn:click'));
    }
  };
  return (
    <div className="svg-black-btn" onClick={handleClick}>
      <img
        style={{ width: '100%', height: 'auto' }}
        src={smartphonePng}
        alt="smartphone icon"
      />
    </div>
  );
};

export default SvGBlackBtn;
